import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import RelatedPostsContainer from "~/Containers/RelatedPostsContainer";
import Tile from "~/Components/Tile";

const RelatedPostsSection = ({ postId }) => {
  if (!postId) return null;
  return (
    <RelatedPostsContainer
      id={postId}
      render={({ posts }) => {
        if (!posts || posts.length === 0) return null;
        return (
          <div style={{ marginTop: "30px" }}>
            <div className="pageTitle">Related Posts</div>
            <Row noGutters className="minimalGutter">
              {posts.map((post) => (
                <Col xl={4} lg={6} xs={12} key={post.id}>
                  <Tile archive otd={post} />
                </Col>
              ))}
            </Row>
          </div>
        );
      }}
    />
  );
};

export default RelatedPostsSection;
